import { __decorate } from "tslib";
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import UserModule from "@/store/modules/user.module";
import Loader from "../../../components/widgets/loader.vue";
import Simplebar from "simplebar-vue";
import EcGrid from "@/components/widgets/EcGrid.vue";
import SectionLoader from "../../../components/widgets/SectionLoader.vue";
import DeleteComponent from "@/components/deleteComponent.vue";
import { toaster } from "@/utilities/toaster";
/**
 * User Listing Component
 */
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let UsersListing = /** @class */ (() => {
    let UsersListing = class UsersListing extends Mixins(BaseMixer) {
        constructor() {
            // DATA
            super(...arguments);
            this.pageIsLoading = true;
            this.isPageLoading = false;
            this.isPageChanged = false;
            this.searchKey = "";
            this.initialSortBy = {
                field: "firstName",
                type: "none",
            };
            this.title = "Users";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Users",
                    active: true,
                },
            ];
            this.showModal = false;
            this.isLoading = false;
            // Grid
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.isPageIsDirty = false;
            this.columns = [
                {
                    field: "firstName",
                    label: "First Name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "First Name",
                    },
                },
                {
                    field: "lastName",
                    label: "Last Name",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Last Name",
                    },
                },
                {
                    field: "emailId",
                    label: "Email",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Email",
                    },
                },
                {
                    field: "organization",
                    label: "Organization",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Organization",
                    },
                },
                {
                    field: "role",
                    label: "Role",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Please Select",
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Please Select",
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "user-action",
                    tdClass: "no-row-click",
                    sortable: false,
                },
            ];
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "firstName",
                    type: "none",
                },
                page: 1,
                pageSize: 10,
            };
            this.statuses = ["Active", "Inactive"];
            this.totalCount = 0;
            this.showDeleteModal = false;
        }
        // METHODS
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            var searchData = {
                //gridOption: {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            UserModule.AssignSearchParams(searchData);
            UserModule.GetAllUsers(searchData).then((response) => {
                this.isPageIsDirty = false;
                this.totalCount = response.totalCount;
                this.isGridLoading = false;
            });
        }
        clearFilter() {
            this.serverParams.columnFilters = {};
            // this.serverParams.page = this.initialPage;
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        get rows() {
            return UserModule.users;
        }
        get roles() {
            return UserModule.userRoles.map((x) => x.value);
        }
        //Methods
        onRowClick(params) {
            var nodeClass = params.event.target.className;
            if (nodeClass != "vgt-left-align no-row-click" && nodeClass != "no-row-click") {
                this.$router.push({
                    name: "ViewUser",
                    params: { userId: params.row.id },
                });
            }
        }
        //Computed
        get users() {
            return UserModule.users;
        }
        get filteredUsers() {
            if (this.searchKey != "") {
                return UserModule.users.filter((x) => x.firstName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1 || x.lastName.toLowerCase().indexOf(this.searchKey.toLowerCase()) > -1);
            }
            return UserModule.users;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditUser" && from.name != "ViewUser") {
                UserModule.ClearSearchParams();
            }
            next();
        }
        initialize() {
            var value = UserModule.searchParams;
            if (value != null) {
                this.isPageIsDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                value.columnFilters.forEach((item) => {
                    this.serverParams.columnFilters[item.name] = item.value;
                });
                this.initialSortBy = value.sort;
            }
        }
        get gridParams() {
            return UserModule.searchParams;
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.isPageIsDirty = true;
                this.gridParams.columnFilters.forEach((item) => {
                    gridColumns[item.name] = item.value;
                });
            }
        }
        deleteuser(id) {
            this.isPageChanged = false;
            this.showDeleteModal = true;
            this.userId = id;
        }
        deletingUser() {
            this.showDeleteModal = false;
            this.isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            UserModule.DeleteUser(this.userId).then((f) => {
                if (f) {
                    if (this.isPageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                    toaster.ShowSuccess("User has been deleted successfully.");
                    this.loadItems();
                }
            });
        }
        cancelDeletion() {
            this.isPageChanged = false;
            this.showDeleteModal = false;
            this.userId = "";
        }
        //Lifecycle
        created() {
            this.initialize();
            UserModule.GetRoles().then((res) => {
                if (res) {
                    this.columns.forEach((column) => {
                        if (column.field === "role" && column.filterOptions.filterDropdownItems.length === 0) {
                            column.filterOptions.filterDropdownItems = this.roles;
                        }
                        else if (column.field === "status" && column.filterOptions.filterDropdownItems.length === 0) {
                            column.filterOptions.filterDropdownItems = this.statuses;
                        }
                    });
                    this.assignColumnFilters();
                }
            });
        }
    };
    UsersListing = __decorate([
        Component({
            name: "UsersListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                Simplebar,
                SectionLoader,
                EcGrid,
                DeleteComponent,
            },
        })
    ], UsersListing);
    return UsersListing;
})();
export default UsersListing;
